import { create } from 'zustand';
import http from '@/services/http';
import { DEFAULT_HEADERS } from '@/services/constants.service';
import { getUserProfile } from '@/services/user.service';

const useClaudeModelsModalStore = create((set) => ({
  // Modal state
  isOpen: false,
  isLoading: false,
  hasBeenShown: false,

  // Actions
  setIsOpen: (isOpen) => set({ isOpen }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setHasBeenShown: (hasBeenShown) => set({ hasBeenShown }),

  // Check if modal should be shown (once per user)
  checkAndShowModal: async () => {
    try {
      set({ isLoading: true });

      // Fetch user profile to check if modal has been seen
      try {
        const profileResponse = await getUserProfile();
        const profile = profileResponse.data;

        // If modal has NOT been seen (false), show it
        if (profile.seen_pop_up_claude_new_models === false) {
          set({ isOpen: true, hasBeenShown: true, isLoading: false });
          return true;
        } else {
          set({ isLoading: false });
          return false;
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        set({ isLoading: false });
        return false;
      }
    } catch (error) {
      console.error('Error checking modal status:', error);
      set({ isLoading: false });
      return false;
    }
  },

  // Handle modal close
  handleClose: () => {
    // Close modal immediately without waiting for tracking
    set({ isOpen: false });

    // Fire tracking request in background (don't await)
    http.post(
      import.meta.env.VITE_APP_BASE_API + 'pop_up_track/?event_type=pop_up_claude_new_models_4_5',
      {},
      { headers: DEFAULT_HEADERS }
    ).catch((error) => {
      console.error('Error tracking close event:', error);
    });
  },

  // Handle try now action
  handleTryNow: () => {
    // Fire tracking request in background (don't await)
    http.post(
      import.meta.env.VITE_APP_BASE_API + 'pop_up_track/?event_type=pop_up_claude_new_models_4_5',
      {},
      { headers: DEFAULT_HEADERS }
    ).catch((error) => {
      console.error('Error tracking try now event:', error);
    });
  },

  // Reset store (for logout)
  reset: () => set({
    isOpen: false,
    isLoading: false,
    hasBeenShown: false
  })
}));

export default useClaudeModelsModalStore;

